import { render, staticRenderFns } from "./UIEI.vue?vue&type=template&id=efe6b866"
import script from "./UIEI.vue?vue&type=script&lang=js"
export * from "./UIEI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports